document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('quantity-input').forEach((wrapper) => {
    const input = wrapper.querySelector('.quantity__input');
    const display = wrapper.querySelector('.quantity__padded-display');
    if (!input || !display) return;

    const updateDisplay = () => {
      const val = parseInt(input.value, 10) || 0;
      display.textContent = val < 10 ? '0' + val : String(val);
    };

    updateDisplay();
    input.addEventListener('input', updateDisplay);
    input.addEventListener('change', updateDisplay);
    // covers stepUp/stepDown triggered by the +/- buttons
    wrapper.addEventListener('click', () => setTimeout(updateDisplay, 0));
  });
});